import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const BaseTextForm: React.FC<TextFieldProps> = (props) => {
  return <TextField fullWidth {...props} />;
};

export const TextForm = styled(BaseTextForm)(() => ({
  width: 'calc(100% - 100px)',
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-input': {
      height: '39px',
      padding: '6px 14px',
      color: '#000',
    },
    '& fieldset': {
      border: 0,
      color: '#000',
    },
    '&.Mui-error::after': {
      content: '""',
      background: '#e855e1',
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: 0.5,
    },
    borderRadius: 0,
    color: '#000',
  },
}));
